import CreateProjectButton from '../../../components/create-project-button/CreateProjectButton';
import styles from './organization-cta.module.less';

export const OrganizationCta = ({ id }) => {
    const ctaText = `Start en spleis`;

    return (
        <div className={styles.createSpleis}>
            <div className={styles.callToActionBox}>
                <CreateProjectButton action="from-org-page" label={`${id}`}>
                    {ctaText}
                </CreateProjectButton>
            </div>
        </div>
    );
};

export default OrganizationCta;
